import './MatchIndex.less';

import React, { FC } from 'react';
import clsx from 'clsx';

const MatchIndex: FC<{ index: number; otherClass?: string }> = ({ index, otherClass }) => (
    <div className={clsx('match-index text-bold flex-center fs-16', otherClass)}>{index}</div>
);

export default MatchIndex;
